import React, { useEffect, useState } from 'react';
import './LandingPage.css';
import logo from './logo.png';

const APP_STORE_URL =
  'https://apps.apple.com/ie/app/swapit-outsmart-your-craving/id6769524499';

export default function LandingPage() {
  const [isTikTokBrowser, setIsTikTokBrowser] = useState(false);
  const [isCheckingBrowser, setIsCheckingBrowser] = useState(true);

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera || '';

    const isTikTok =
      /TikTok|TTWebView|BytedanceWebview|musical_ly_|trill|ByteLocale/i.test(ua);

    setIsTikTokBrowser(isTikTok);
    setIsCheckingBrowser(false);

    if (!isTikTok) {
      window.location.replace(APP_STORE_URL);
    }
  }, []);

  if (isCheckingBrowser) {
    return null;
  }

  return (
    <div className="landing-page">
      {/* Giant arrow pointing to the three-dot menu in the top-right corner */}
      <div className="corner-arrow" aria-hidden="true">
        <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 102 C 40 60, 70 30, 104 18"
            stroke="#00FF85"
            strokeWidth="9"
            strokeLinecap="round"
          />
          <path
            d="M104 18 L 70 22 M104 18 L 100 52"
            stroke="#00FF85"
            strokeWidth="9"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <main className="landing-container">

        <h1 className="step-title">
          Tap the <span className="dots">⋯</span> 
        </h1>

        <p className="step-instruction">
          then press <strong>“Open in browser”</strong>
        </p>

        <br></br>
        <p className="step-eyebrow">to open SwapIt</p>


        <div className="brand">
          <img src={logo} alt="SwapIt" className="brand-logo" />
          <span className="brand-name">SwapIt</span>
        </div>
      </main>
    </div>
  );
}
